var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user && _vm.$can('dashboard_view'))?_c('div',[(_vm.user.role === 'customer_support')?_c('customer-support-dashboard'):_c('normal-dashboard')],1):_c('div',[_c('h3',[_vm._v("Hello")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }